<div class="border-b border-zinc-200 px-4 py-3 dark:border-zinc-800">
  <div class="grid grid-cols-1 sm:hidden">
    <select
      aria-label="Select stats view"
      class="col-start-1 row-start-1 w-full appearance-none rounded-md border border-zinc-200 bg-white py-2 pl-3 pr-8 text-sm text-primary outline-none focus:border-primary focus:ring-1 focus:ring-primary dark:border-zinc-700 dark:bg-zinc-900"
      [value]="activeRoute()"
      (change)="selectMobile($event)"
    >
      @for (item of items(); track item.route) {
        <option [value]="item.route">{{ item.label }}</option>
      }
    </select>
    <svg
      viewBox="0 0 16 16"
      fill="currentColor"
      data-slot="icon"
      aria-hidden="true"
      class="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-secondary"
    >
      <path
        d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z"
        clip-rule="evenodd"
        fill-rule="evenodd"
      />
    </svg>
  </div>

  <nav aria-label="Stats views" class="hidden sm:flex space-x-2">
    @for (item of items(); track item.route) {
      <button
        type="button"
        class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
        [class]="getButtonClass(item)"
        [attr.aria-current]="activeRoute() === item.route ? 'page' : null"
        (click)="goToItem(item)"
      >
        {{ item.label }}
      </button>
    }
  </nav>
</div>
